module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-md"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.searchForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应用名称"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchForm.appIndex),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "appIndex", $$v)
      },
      expression: "searchForm.appIndex"
    }
  }, _vm._l((_vm.apps), function(item) {
    return _c('el-option', {
      key: item.appIndex,
      attrs: {
        "label": item.appName,
        "value": item.appIndex
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "native-type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getAppProducts($event)
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.showDialog(false)
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "native-type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.putAway($event)
      }
    }
  }, [_vm._v("一键上架")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "native-type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.soldOut($event)
      }
    }
  }, [_vm._v("一键下架")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.appProducts.rows,
      "stripe": true,
      "border": ""
    }
  }, [(false) ? _c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "80",
      "label": "ID"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appIndex",
      "label": "应用名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.findAppName(scope.row.appIndex)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productIds",
      "label": "商品ids"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "min-width": "160",
      "width": "230"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.showDialog(scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppProducts(scope.row)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppCache(scope.row.appIndex)
            }
          }
        }, [_vm._v("清缓存")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "padding-vertical-md",
    attrs: {
      "background": "",
      "current-page": _vm.appProducts.currentPage,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.appProducts.pageSize,
      "page-count": _vm.appProducts.totalPages,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.appProducts.count
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.appProducts, "currentPage", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "update",
    attrs: {
      "el-dialog": "",
      "title": _vm.title,
      "visible": _vm.showEditorDialog,
      "before-close": _vm.handleBeforeCloseDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditorDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "formData",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应用",
      "prop": "appIndex"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": !!_vm.formData.id
    },
    model: {
      value: (_vm.formData.appIndex),
      callback: function($$v) {
        _vm.$set(_vm.formData, "appIndex", $$v)
      },
      expression: "formData.appIndex"
    }
  }, _vm._l((_vm.apps), function(item) {
    return _c('el-option', {
      key: item.appIndex,
      attrs: {
        "label": item.appName,
        "value": item.appIndex
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "products",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.products,
      "border": "",
      "height": "250"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "icon",
      "label": "商品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.icon) ? _c('img', {
          attrs: {
            "src": scope.row.icon,
            "width": "40%",
            "height": "40%",
            "alt": "icon"
          }
        }) : _c('span', [_vm._v("Icon")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格/元"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("currency")(scope.row.price)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sellCount",
      "label": "钻石数量"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-top-sm",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "native-type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d284cb9a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/appProducts.vue
// module id = 68hq
// module chunks = 3